export default {
  unsaved: {
    title: 'Vil du gemme dine ændringer?',
    description: 'Du har foretaget ændringer i dette trin, som endnu ikke er gemt.',
    discard: 'Kassér',
    save_and_continue: 'Gem og fortsæt',
  },
  title: 'Opsæt din restaurant',
  nav: {
    completed: 'Fuldført',
    locked: 'Håndteres af din udbyder',
    aria_label: 'Trin til lancering',
    step_label: 'Trin {{number}}',
    section_label: 'Lancering',
    back_to_home: 'Tilbage til start',
  },
  owner_invite: {
    hint: 'Foretrækker du, at restaurantejeren selv afslutter opsætningen? Inviter vedkommende, så fortsætter han eller hun, hvor du slap.',
    sent: 'Invitation sendt til {{name}} ({{email}}) den {{date}}.',
  },
  footer: {
    step_of: 'Trin {{current}} af {{total}}',
  },
  buttons: {
    next_task: 'Næste opgave',
    cancel: 'Annuller',
    back: 'Tilbage',
    next: 'Fortsæt',
    save: 'Gem',
    exit: 'Afslut opsætning',
    retry: 'Prøv igen',
  },
  errors: {
    progress_load_failed: 'Vi kunne ikke indlæse opsætningsforløbet for denne restaurant.',
    linked_company_unavailable: 'Dette link er til en restaurant, du ikke kan åbne, så du er på din nuværende.',
  },
  placeholder: {
    title: 'Dette trin kommer snart',
    description: 'Guidens ramme og fremdriftssporing er klar. Denne fase bygges næste gang.',
  },
  new_restaurant: {
    title: 'Ny restaurant',
    menu: {
      title: 'Menu',
      description: 'En demo springer onboarding over, så importér dens menu nu.',
    },
    demo: {
      title: 'Ny demo',
      description: 'En demorestaurant til test – den springer det meste af onboarding over.',
      label: 'Opret demo',
    },
    description: 'Fortæl os, hvor denne restaurant ligger. Vi slår den op på Google Maps.',
  },
  location: {
    edit_description: 'Opdater, hvor denne restaurant ligger.',
    cta: 'Opret restaurant',
    section: {
      address: 'Grundlæggende oplysninger',
      group: 'Brand',
      group_description: 'Er denne lokation en del af et brand, du allerede har?',
    },
    form: {
      name: {
        label: 'Restaurantens navn',
        placeholder: 'Søg efter din restaurant…',
        help: 'Begynd at skrive for at søge efter denne restaurant på Google Maps.',
      },
      address: {
        label: 'Gadeadresse',
        placeholder: 'Gade og husnummer',
      },
      city: {
        label: 'By',
      },
      zip_code: {
        label: 'Postnummer',
      },
      country: {
        label: 'Land',
      },
      region: {
        label: 'Stat / region',
        placeholder: 'Vælg en stat eller region',
      },
    },
    group: {
      aria_label: 'Brandindstillinger',
      deferred_hint: 'Du vælger brandnavn og webadresse i det sidste trin.',
      existing: {
        title: 'Tilføj til et eksisterende brand',
        description: 'En anden lokation under et brand, du allerede driver.',
        select_label: 'Brand',
        select_placeholder: 'Vælg et brand',
      },
      new: {
        title: 'Opret et nyt brand',
        description: 'En enkelt restaurant eller den første lokation i et nyt brand.',
      },
    },
    toasts: {
      update_failed: 'Lokationen kunne ikke gemmes. Prøv igen.',
      created: 'Restaurant oprettet',
      create_failed: 'Restauranten kunne ikke oprettes. Prøv igen.',
    },
  },
  domain: {
    url_setup: {
      title: 'Adresse til onlinebestilling',
      description: 'Hvor gæsterne afgiver bestillinger.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'dit domæne til onlinebestilling',
        title: 'Brug vores generiske domæne',
      },
      custom: {
        title: 'Tilslut dit eget domæne',
        description: 'Brug et domæne, restauranten allerede ejer.',
      },
    },
    toasts: {
      save_failed: 'Adressen til onlinebestilling kunne ikke gemmes. Prøv igen.',
    },
  },
  go_live: {
    subtitle: 'Kontrollér, at alle trin er udført, og aktivér derefter live-bestillinger.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Kun bogstaver, tal og bindestreger. Du kan ændre det senere, men den gamle adresse holder op med at virke.',
      title: 'Adresse til onlinebestilling',
      description: 'Det er her, dine kunder bestiller. Du kan ændre det senere.',
      label: 'Tilpas den med restaurantens navn',
      placeholder: 'bella-italia',
      preview: 'Din bestillingsside:',
      save: 'Gem URL',
      saved: 'Adresse til onlinebestilling gemt',
      save_failed: "URL'en kunne ikke gemmes. Prøv igen.",
      status: {
        checking: 'Kontrollerer tilgængelighed…',
        available: 'Tilgængelig',
        taken: 'Denne URL er allerede i brug',
        invalid: 'Brug kun bogstaver, tal, bindestreger og understregninger',
        error: 'Tilgængeligheden kunne ikke kontrolleres – prøv igen',
      },
    },
    domain: {
      title: 'Eget domæne (valgfrit)',
      description: 'Brug dit eget domæne i stedet for adressen fra FoodAmigos.',
      add: '+ Tilføj eget domæne',
      hide: 'Skjul eget domæne',
      label: 'Dit domæne',
      placeholder: 'shop.myrestaurant.com',
      save: 'Gem',
      show_records: 'Vis DNS-poster',
      hint: 'Kun til bestilling – din hjemmeside skal bruge et andet domæne. For eksempel order.myrestaurant.com til shoppen og myrestaurant.com til hjemmesiden.',
      records_after_save:
        'Når du har gemt domænet, viser vi de præcise poster, du skal tilføje hos din DNS-udbyder – et hoveddomæne (myrestaurant.com) og et underdomæne (order.myrestaurant.com) kræver forskellige poster.',
      saved: 'Eget domæne gemt',
      save_failed: 'Domænet kunne ikke gemmes. Prøv igen.',
      unconfirmed: {
        title: 'Livegang venter ikke på dette domæne',
        description:
          'Indtil dets poster er bekræftet, forbliver bestillingssiden på sin standardadresse, og restauranten kan gå live der. Når de er bekræftet – det kan tage op til 48 timer – leverer domænet automatisk bestillingssiden.',
      },
    },
    locations: {
      title: 'Bekræft lokationer',
      description: 'Hver lokation i dit brand får sin egen bestillingsadresse. Bekræft eller rediger dem nedenfor.',
      save: 'Gem lokationer',
      saved: "Lokations-URL'er gemt",
      save_failed: "En eller flere lokations-URL'er kunne ikke gemmes. Prøv igen.",
    },
    preflight: {
      title: 'Før du går live',
      description: 'Udfør disse for at aktivere live-bestillinger.',
      url_setup: 'Bestillingsadresse opsat',
      online_payment: {
        your_provider: 'din udbyder',
        payments_live: '{{title}} · udført',
        online_payments_off: '{{title}} · modtager ikke onlinebetalinger',
        waiting_for_provider: '{{title}} · venter på {{provider}}',
        hosted_not_finished: '{{title}} · afslut hos {{provider}}',
        action_needed: '{{title}} · handling påkrævet',
        waiting_for_partner: '{{title}} · venter på din partner',
        not_set_up: '{{title}} · ikke opsat',
        business_details_missing: '{{title}} · tilføj virksomhedsoplysninger til udbetalinger',
      },
    },
    failed_checks: {
      title: 'Nogle få ting kræver stadig opmærksomhed',
      items: {
        name: 'Restaurantens navn',
        logo_url: 'Logo',
        pictures: 'Galleribilleder',
        menu_uploaded: 'Menu',
        opening_hours: 'Åbningstider',
        address: 'Adresse',
        storefront: 'Bestillingsadresse',
        payments_configured: 'Betalinger',
        stripe_billing: 'Fakturering',
        test_orders: 'Testordre',
        google_business: 'Google Business-profil',
        master_promo_code: 'Velkomstpromokode',
        flyers_ordered: 'Flyers bestilt',
        identity: 'Restauranttype og køkkener',
        billing_payment_method: 'Betalingsmetode',
        billing_license: 'Licens',
        business_name: 'Virksomheds-/restaurantnavn',
        payment_method: 'Kontant eller onlinebetaling',
        stripe_processing_fee: 'Partnerens behandlingsgebyr',
      },
      force: 'Gå live alligevel',
      blocker: '(påkrævet)',
      link: 'Åbn Partner Billing',
    },
    error: 'Live-ordrer kunne ikke aktiveres. Prøv igen.',
    gate_hint: 'Fuldfør tjeklisten ovenfor for at aktivere Go Live.',
    business_name: {
      label: 'Virksomheds-/restaurantnavn',
      help: 'Vises i dine brugsvilkår og din privatlivspolitik. Brug det navn, din virksomhed handler under.',
      save: 'Gem',
      save_failed: 'Virksomhedsnavnet kunne ikke gemmes. Prøv igen.',
      hint: 'Gem først virksomheds-/restaurantnavnet.',
    },
    cash_only: {
      message:
        'Onlinebetalinger er slået fra — kunderne kan kun betale kontant ved afhentning eller levering, indtil en gateway er tilknyttet og verificeret.',
    },
    payment_blocked: {
      title: 'Aktivér kontantbetaling eller opsæt onlinebetaling for at gå live.',
      payment_method: 'Kunderne har brug for en måde at betale på.',
      turn_on_cash: 'Aktivér kontantbetaling',
      ask_partner: 'Bed din partner om at aktivere kontantbetaling, eller',
      set_up_online: 'opsæt onlinebetaling',
    },
    buttons: {
      go_live: 'Gå live 🚀',
      finish: 'Afslut opsætning',
    },
    celebration: {
      title: 'I er live!',
      title_named: '{{name}} er live!',
      subtitle: 'Din restaurant modtager nu live-ordrer.',
      license: '{{plan}} · aktiv',
      license_trial: '{{plan}} · gratis indtil {{date}}',
      finish: 'Afslut opsætning',
    },
    service_fee: {
      title: 'Servicegebyr',
      headline: 'Tjen ekstra uden at belaste dine restauranter',
      subtitle:
        'Tilføj et lille servicegebyr, som gæsterne betaler ved checkout. Du beholder halvdelen. Det er slået fra, medmindre du slår det til.',
      subtitle_share:
        'Tilføj et lille servicegebyr, som gæsterne betaler ved checkout. Du beholder {{share}}%. Det er slået fra, medmindre du slår det til.',
      tiles: {
        guest: {
          title: 'Betales af gæsten',
          description: 'Vises ved checkout, ligesom i leveringsapps.',
        },
        share: {
          title: 'Halvdelen går til dig',
          title_share: '{{share}}% går til dig',
          description: 'Fordeles {{share}}/{{rest}} med FoodAmigos.',
        },
        choice: {
          title: 'Dit valg',
          description: 'Slået fra som standard. Kan ændres når som helst.',
        },
      },
      preview: {
        title: 'Det ser gæsterne ved checkout',
        subtotal: 'Ordresubtotal',
        fee: 'Servicegebyr',
        fee_terms: '({{percentage}}%, maks. {{max}})',
        guest_pays: 'Gæsten betaler',
        split_partner: '<strong>Du {{amount}}</strong> pr. ordre',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'Restaurantens ordreværdi er uændret.',
      },
      earnings: {
        title: 'Det kan du tjene på denne restaurant',
        orders: 'Onlineordrer pr. måned',
        average_order: 'Gennemsnitlig ordre',
        per_month: 'om måneden til dig',
        collected: '{{amount}} opkrævet fra gæster pr. måned. Din andel: {{share}}%. Kun et estimat.',
        effective_rate: 'Effektiv gebyrsats på tværs af alle ordrer: {{rate}}',
      },
      choice: {
        question: 'Tilføje et servicegebyr for denne restaurant?',
        enabled: {
          title: 'Tilføj servicegebyr',
          recommended: 'Anbefalet: {{percentage}}%, maks. {{max}}',
          description: 'Gæster betaler et lille gebyr. Du tjener en andel.',
        },
        skipped: {
          title: 'Intet servicegebyr',
          description: 'Gæster betaler kun menupriser.',
        },
      },
      footer: {
        enabled:
          'Gæster betaler {{percentage}}%, maks. {{max}} pr. ordre. Kan ændres når som helst under <settings>Ordreindstillinger → Servicegebyr</settings>.',
        skipped:
          'Intet servicegebyr for nu. Kan ændres når som helst under <settings>Ordreindstillinger → Servicegebyr</settings>.',
      },
      enabled:
        'Servicegebyret er nu aktivt på denne restaurant med {{percentage}} %, begrænset til maks. {{max}} pr. ordre. Det gælder for alle nye ordrer fra nu af. Du kan til enhver tid ændre det under <settings>Ordreindstillinger → Servicegebyr</settings>.',
      enabled_partner_default:
        'Servicegebyret er nu aktivt på denne restaurant. Din partnerstandard gælder: {{percentage}} %, begrænset til maks. {{max}} pr. ordre. Det gælder for alle nye ordrer fra nu af. Du kan til enhver tid ændre det under <settings>Ordreindstillinger → Servicegebyr</settings>.',
      buttons: {
        enable: 'Aktivér servicegebyr',
        continue_without: 'Fortsæt uden gebyr',
      },
      skipped:
        'Gæster på denne restaurant betaler intet servicegebyr. Du kan til enhver tid slå det til under <settings>Ordreindstillinger → Servicegebyr</settings>.',
      toasts: {
        save_failed: 'Valget af servicegebyr kunne ikke gemmes. Prøv igen.',
      },
    },
  },
  toasts: {
    save_failed: 'Dine ændringer kunne ikke gemmes. Prøv igen.',
    saved: 'Gemt',
  },
  optional: 'Valgfrit',
  identity: {
    min_cuisine_hint: 'Vælg mindst ét køkken for at fortsætte.',
    sections: {
      restaurant_type: {
        title: 'Restauranttype',
        description: 'Hvilken type sted er det?',
      },
      cuisine: {
        title: 'Køkkentyper',
        description: 'Vælg mindst én.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Anbefalet',
      import: {
        title: 'Importér fra en platform',
        description: 'Hent menuen fra GloriaFood, Wolt, Lieferando, Deliveroo og flere.',
      },
      manual: {
        title: 'Opbyg din menu fra bunden',
        description: 'Opret kategorier og varer manuelt i menubyggeren.',
      },
    },
    import: {
      title: 'Importér fra eksisterende platform',
      in_progress: {
        title: 'Importerer din menu…',
        description: 'Det tager normalt under to minutter. Vi fuldfører dette trin, så snart det er færdigt.',
      },
      failed: {
        title: 'Importen blev ikke færdig',
        description: 'Menuimporten kunne ikke gennemføres. Tjek oplysningerne, og prøv igen.',
      },
      blocked: {
        until: 'Sat på pause indtil {{time}}',
        release: 'Frigiv linket',
        released: 'Linket er frigivet. Du kan starte importen igen.',
        release_failed: 'Linket kunne ikke frigives. Prøv igen om et øjeblik.',
      },
      stalled: {
        title: 'Importerer stadig…',
        description:
          'Importen tager længere tid end normalt. Den kører muligvis stadig i baggrunden – tjek igen om et øjeblik. Hvis du starter en ny import nu, kan menuen blive importeret to gange.',
      },
    },
    manual: {
      title: 'Opbyg din menu fra bunden',
      description:
        'Menubyggeren åbner med en tom menu. Dette trin er fuldført, når der findes mindst én kategori og én vare.',
      open_editor: 'Åbn menubygger',
      waiting: {
        title: 'Venter på din første menuvare',
        description: 'Når du tilføjer en vare i menueditoren, kan dette trin fuldføres.',
      },
      found: {
        title: 'Menuvarer fundet',
        description: 'Super – du kan fortsætte til næste trin.',
      },
    },
    complete: {
      title: 'Menu klar',
      description: 'Din menu er på plads. Du kan til enhver tid gennemgå den i menueditoren.',
    },
    buttons: {
      start_import: 'Start import',
      importing: 'Importerer…',
      retry: 'Prøv import igen',
      check_again: 'Tjek igen',
      continue: 'Fortsæt',
      skip: 'Spring over for nu',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'denne restaurant',
    location: {
      title: 'Placering',
      description: 'Hvor ligger restauranten, og hvilket brand tilhører den?',
    },
    identity: {
      title: 'Identitet',
      description: 'Restauranttype og køkkener.',
    },
    brand: {
      title: 'Brand',
      description: 'Logo, farver og galleri.',
    },
    operations: {
      title: 'Lokationsoplysninger',
      description:
        'Konfigurer, hvordan {{name}} modtager ordrer. Dette er minimumskravet, før der kan modtages ordrer.',
    },
    menu: {
      title: 'Menu',
      description:
        'Få {{name}}s menu ind på platformen. Importér den fra en eksisterende platform på under to minutter, eller opbyg den fra bunden.',
    },
    domain: {
      title: 'Domæne',
      description: 'Webadressen, som kunderne bruger til at bestille hos denne restaurant.',
    },
    go_live: {
      title: 'Go Live',
      description: 'Aktivér live-ordrer.',
    },
    payouts: {
      title: 'Onlinebetaling',
      description: 'Hvordan denne restaurant modtager betaling online.',
    },
    service_fee: {
      title: 'Servicegebyr',
      description:
        'Om gæster betaler et servicegebyr i kassen. Du kan ændre det senere under Ordreindstillinger → Gebyrer.',
    },
    bank_account: {
      title: 'Bankkonto',
      description:
        'Hvor udbetalinger sendes hen. Ikke nødvendig for at gå live: Betalinger venter på saldoen, indtil en konto er tilføjet.',
    },
  },
  business_details: {
    locked: 'Disse oplysninger er verificeret hos din betalingsudbyder. Kontakt FoodAmigos for at ændre dem.',
    section: {
      title: 'Virksomhedsoplysninger',
    },
    fields: {
      business_type: {
        label: 'Virksomhedstype',
        options: {
          company: 'Selskab (ApS, A/S, Ltd, Inc – en registreret juridisk enhed)',
          individual: 'Enkeltmandsvirksomhed (du ejer og driver virksomheden personligt)',
        },
      },
      owner_first_name: { label: 'Ejerens fornavn' },
      owner_last_name: { label: 'Ejerens efternavn' },
      legal_name: {
        label: 'Virksomhedens juridiske navn',
        individual: 'Du driver virksomheden personligt, så ejerens navn bruges som virksomhedens juridiske navn.',
      },
      legal_address: { label: 'Registreret adresse' },
      legal_city: { label: 'By' },
      legal_state: { label: 'Region eller delstat' },
      legal_zip_code: { label: 'Postnummer' },
      legal_country: { label: 'Land' },
      tax_id: {
        generic: 'Skatte- eller registreringsnummer',
        personal: 'Kun de sidste fire cifre vises. Lad feltet stå uændret for at beholde nummeret.',
        hint: 'For eksempel {{example}}.',
        invalid:
          'Dette svarer ikke til det sædvanlige format for dette land og denne virksomhedstype, for eksempel {{example}}.',
      },
      is_vat_registered: { label: 'Virksomheden er momsregistreret' },
      vat_id: {
        label: 'Momsnummer',
        help: 'Starter med {{country}}, efterfulgt af 8 til 12 bogstaver eller cifre.',
        invalid: 'Momsnummeret skal starte med {{country}}, efterfulgt af 8 til 12 bogstaver eller cifre.',
        help_unprefixed: 'Dit moms- eller skatteregistreringsnummer, som udstedt.',
        invalid_unprefixed: 'Dette ligner ikke et momsnummer: brug 5 til 25 bogstaver eller cifre.',
      },
    },
    toasts: {
      save_failed: 'Dine virksomhedsoplysninger kunne ikke gemmes. Prøv igen.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Kortnavn',
        placeholder: 'fx Amigo Pizza',
        tooltip: 'Et kortere visningsnavn, der bruges i webshoppen og på kvitteringer.',
      },
      primary_color: {
        label: 'Primær farve',
        invalid: 'Angiv en gyldig hex-farve, fx #1A73E8.',
      },
    },
    sections: {
      short_name: 'Navn',
      short_name_hint: 'Bruges på tværs af webshoppen, kvitteringer og notifikationer.',
      logo_and_colour: 'Logo og primær brandfarve',
      logo: 'Upload logo',
      logo_hint: 'Hvis du lader feltet stå tomt, bruges dit brandlogo.',
      gallery: 'Galleribilleder',
      gallery_hint: 'Tilføj op til {{max}} billeder af din restaurant. Træk for at ændre rækkefølgen.',
      gallery_count: '{{count}} af {{max}} tilføjet',
    },
    toasts: {
      image_uploaded: 'Billede uploadet',
      image_upload_failed: 'Billedet kunne ikke uploades. {{error}}',
      save_failed: 'Dine brandoplysninger kunne ikke gemmes. Prøv igen.',
    },
  },
  operations: {
    contact: {
      title: 'Kontakt',
      description: 'Bruges til ordrenotifikationer og kundekommunikation.',
      phone: {
        label: 'Restaurantens telefonnummer',
        placeholder: '+49 30 1234567',
        invalid: 'Angiv et komplet internationalt telefonnummer, f.eks. +49 30 1234567',
      },
      email: { label: 'Restaurantens e-mail', placeholder: 'orders@restaurant.com' },
    },
    methods: {
      title: 'Bestillingsmetoder',
      description: 'Hvordan kunder kan bestille, og hvor lang tid hver metode tager.',
      pickup: {
        label: 'Afhentning',
        prep_time: { label: 'Gennemsnitlig tilberedningstid (min.)' },
      },
      delivery: {
        label: 'Levering',
        delivery_time: { label: 'Gennemsnitlig leveringstid (min.)' },
        advanced_zones: 'Avanceret zoneopsætning',
      },
    },
    timing: {
      title: 'Bestillingstidspunkt',
      description: 'Hvornår kunder kan afgive bestillinger – nu, senere eller i forvejen.',
      at_least_one: 'Aktivér ASAP- eller planlagte bestillinger (mindst én er påkrævet).',
      asap: { label: 'Acceptér ASAP-bestillinger' },
      scheduled: { label: 'Acceptér planlagte bestillinger' },
      reminders: { label: 'Send en automatisk påmindelse, før en planlagt bestilling forfalder' },
      pre_order: {
        label: 'Tillad forudbestillinger til fremtidige dage',
        days: { label: 'Hvor mange dage frem (0-31)' },
      },
    },
    tax: {
      title: 'Moms',
      description:
        'Den sats, der anvendes på denne restaurants produkter. Den tager udgangspunkt i satsen for regionen – ændr den kun, hvis denne restaurant opkræver noget andet.',
      rate: { label: 'Momssats', placeholder: 'f.eks. 7' },
      dedicated: { label: 'Momsen varierer efter produkt' },
    },
    hours: {
      title: 'Åbningstider',
      description: 'De dage og tidspunkter, hvor denne restaurant modtager bestillinger.',
      same_every_day: 'Samme åbningstider hver dag',
      split_shifts: {
        title: 'Denne restaurant har delte åbningstider',
        description:
          'Nogle dage har mere end én åbningsperiode (f.eks. en frokost- og en aftenvagt). Den enkle editor her viser én periode pr. dag, så vi beholder dine eksisterende åbningstider uændret – rediger delte vagter under Bestillingsindstillinger → Åbningstider.',
      },
    },
    toasts: {
      save_failed: 'Dine driftsindstillinger kunne ikke gemmes. Prøv igen.',
    },
  },
  online_payment: {
    question: 'Vil du modtage onlinebetalinger for denne restaurant?',
    yes: 'Ja',
    not_now: 'Ikke nu',
    declined:
      'Kunderne betaler ved afhentning eller levering. Du kan til enhver tid aktivere onlinebetalinger under Indstillinger.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Betalinger er endnu ikke sat op for din partnerkonto',
        description:
          'En administrator på din partnerkonto skal vælge, hvem der behandler betalinger, før denne restaurant kan modtage onlinebetalinger. Du kan fortsætte med de andre trin i mellemtiden.',
      },
    },
    continue_to_go_live: 'Fortsæt til Go Live',
    platform_line: 'Betalinger for denne restaurant går via FoodAmigos-betalinger.',
    only_connection: 'Betalinger går via {{name}} (din eneste tilsluttede udbyder).',
    partner_issue: {
      title: 'Din partner {{partner}} skal gøre deres betalingsudbyder færdigopsat',
      description:
        'Deres betalingsudbyder kan endnu ikke onboarde restauranter. Vi har givet dem besked – dine oplysninger er gemt, så kom tilbage, når de bekræfter, at det er klaret.',
      retry_hint: 'Når det er rettet, skal du fortsætte til udbyderen igen, så prøver vi igen.',
      open_settings: 'Åbn indstillingerne for din betalingsgateway',
    },
    connect_another: 'Tilslut en anden udbyder',
    checking: 'Kontakter {{provider}}…',
    checking_generic: 'Kontakter betalingsudbyderen…',
    retry: 'Prøv igen',
    not_set_up: {
      title: 'Ingen betalingsudbyder tilknyttet endnu',
      description:
        'Din partner tilknytter en betalingsudbyder til denne restaurant. Når det er sket, kan du gøre opsætningen færdig her.',
    },
    choice: {
      title: 'Hvilken af dine tilsluttede udbydere skal denne restaurant bruge?',
      primary: 'Primær',
      confirm: 'Brug denne udbyder',
      cancel: 'Annuller',
    },
    using: 'Bruger {{name}}',
    change: 'Skift',
    payout_details: {
      title: 'Virksomhedsoplysninger til udbetalinger',
      description: 'Kræves af betalingsudbyderen for at verificere din virksomhed og sende udbetalinger.',
      business_type: {
        company: {
          title: 'Virksomhed',
          description: 'ApS, A/S, GmbH, Ltd — en registreret juridisk enhed',
        },
        individual: {
          title: 'Privatperson',
          description: 'Du ejer og driver selv virksomheden',
        },
      },
      registered_address: 'Registreret adresse',
      legal_address: 'Gadeadresse',
      legal_state: 'Stat/region',
      vat_id: 'Momsnummer',
      optional: '(valgfrit)',
      fill_first: 'Udfyld først virksomhedsoplysningerne til udbetalinger ovenfor.',
    },
    hand_off: {
      title: 'Næste: afslut opsætningen hos {{provider}}',
      description:
        '{{provider}} beder om ejerens legitimation i sin egen formular og bruger virksomhedsoplysningerne til udbetalinger ovenfor. Det tager cirka 10 minutter. Bankkontoen kommer efter, at du går live.',
      cta: 'Fortsæt til {{provider}}',
      transition: 'Sender dig videre til {{provider}}…',
      error: 'Vi kunne ikke åbne formularen fra {{provider}}. Prøv igen.',
    },
    states: {
      verified: 'Betalinger er aktive.',
      submitted: {
        title: 'Oplysninger sendt til {{provider}}',
        description:
          'Verificeringen tager normalt 1-2 hverdage. Vi sender en e-mail til restaurantens ejer, når den er færdig.',
        description_email:
          'Verificeringen tager normalt 1-2 hverdage. Vi sender en e-mail til {{email}}, når den er færdig.',
        review: {
          business_type: 'Virksomhedstype',
          legal_name: 'Juridisk navn',
          address: 'Registreret adresse',
          types: {
            company: 'Virksomhed',
            individual: 'Privatperson',
          },
        },
      },
      incomplete: {
        title: 'Du er ikke færdig med {{provider}}',
        description: 'Dine oplysninger er gemt – linket er gyldigt i 2 dage.',
        expired: 'Dine oplysninger er gemt, men linket er udløbet.',
        cta: 'Fortsæt med {{provider}}',
        new_link: 'Hent et nyt link og fortsæt',
        check_details: 'Tjek mine oplysninger først',
      },
      action_needed: {
        title: '{{provider}} mangler én ting mere',
        description:
          '{{provider}} kunne ikke verificere en af de oplysninger, du har angivet. Åbn deres formular igen for at rette det.',
        cta: 'Åbn formularen fra {{provider}} igen',
      },
    },
    connected: {
      title: 'Betalinger går via {{name}}',
      description: 'Denne restaurant er knyttet til kontoen hos {{name}} – der er ikke mere at sætte op her.',
      failed: 'Vi kunne endnu ikke knytte denne restaurant til {{name}}',
    },
    errors: {
      generic: 'Noget gik galt. Prøv igen.',
      load_failed: 'Vi kunne ikke indlæse denne restaurants betalingsopsætning.',
    },
  },
  bank_account: {
    section: {
      title: 'Bankkonto til udbetalinger',
      description: 'Udbetalinger sendes i {{currency}}, den valuta denne restaurant modtager betalinger i.',
    },
    done: 'Tilbage til dashboardet',
    load_failed: 'Vi kunne ikke indlæse denne restaurants bankkonto.',
    retry: 'Prøv igen',
    no_permission: 'Kun restaurantens ejer eller partneren kan angive bankkontoen.',
    confirm_with_provider: 'Bekræft hos Adyen',
    toasts: {
      save_failed: 'Vi kunne ikke gemme bankkontoen. Tjek oplysningerne.',
    },
  },
  payouts: {
    finish_setup: 'Afslut opsætning',
  },
};
